import React from 'react';
import {GridValidRowModel} from '@mui/x-data-grid-pro';
import {StickyDataGrid} from '../../../components/Common/StickyDataGrid';
import {useHardFacts} from '../../../hooks/useHardFacts';
import {ErrorPage} from '../../../pages/ErrorPage';
import {liabilitiesColumns} from './LoansLiabilitiesColumns';

export const LoansLiabilitiesTable: React.FC = () => {
  const {data, error, loading} = useHardFacts();
  const liabilitiesRows = data?.hardFacts?.liabilitiesFacts ?? [];

  if (error) {
    return <ErrorPage text={error.message} />;
  }

  return (
    <StickyDataGrid
      sx={{
        overflowY: 'scroll',
        height: '250px',
      }}
      rowHeight={40}
      rows={liabilitiesRows as readonly GridValidRowModel[]}
      columns={liabilitiesColumns}
      hideFooter
      loading={loading}
    />
  );
};
